<footer>
  <div class="footer-top">
    <div class="container-fluid py-5 px-md-4">
     <div nz-row [nzGutter]="[16, 16]">
        <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="8" >
          <h5>WHO WE ARE?</h5>
          <p>Derivatives are integral to what we do.</p>
        </div>
        <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="8" >
          <h5>Models</h5>
          <ul>
            <li>Smart Veta Hedge</li>
            <li>Benchmark</li>
          </ul>
        </div>
        <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="8" >
          <h5>CONTACT US</h5>
          <p>Veta Partners.<br>
            Kansas, KS<br>
            Email: info&#64;vetaip.com<br>
            Phone: XXX-XXX-XXXX</p>
        </div>
      </div>
    </div>

  </div>
  <div class="copyright-area py-3">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="copyright-item text-center text-light ">
            © 2025 Veta Partners. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>